import { Reveal } from "./Reveal";
import { useLead } from "../lib/store";
import { track } from "../lib/track";
import { WhatsAppIcon } from "./icons";

export default function CtaSection({
  title = "Sudah Punya Destinasi Impian?",
  sub = "Biarkan Beyond Travel membantu menyiapkan perjalanan Anda.",
  testid = "cta-section",
}) {
  const { openLead } = useLead();

  return (
    <section className="relative overflow-hidden bg-tosca-900 py-20 md:py-28" data-testid={testid}>
      <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-tosca-600/40 blur-3xl" />
      <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-gold/20 blur-3xl" />
      <div className="container-x relative flex flex-col items-center gap-5 text-center">
        <Reveal>
          <p className="eyebrow !text-gold">Ready When You Are</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="max-w-2xl font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">{title}</h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="max-w-xl text-sm leading-relaxed text-white/70 sm:text-base">{sub}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-3 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={() => {
                track("click_whatsapp", { source: "cta_section" });
                openLead();
              }}
              className="btn btn-wa !px-8 !py-3.5"
              data-testid={`${testid}-whatsapp`}
            >
              <WhatsAppIcon className="h-5 w-5" /> Konsultasi Gratis via WhatsApp
            </button>
            <button
              onClick={() => {
                track("request_quotation", { source: "cta_section" });
                openLead({ type: "quotation" });
              }}
              className="btn btn-outline-white !px-8 !py-3.5"
              data-testid={`${testid}-quotation`}
            >
              Request Quotation
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
